<template>
  <div class="search-section">
    <div class="divider">
      <h4>بحث في أصحاب المؤسسات</h4>
      <hr
        role="separator"
        aria-orientation="horizontal"
        class="v-divider theme--dark"
      />
    </div>
    <div class="row">
      <div class="col-lg-6 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> إسم صاحب المؤسسة</label>
          <v-autocomplete
            v-model="searchData.enterpriceOwner"
            :search-input.sync="searchOptions.enterpriceOwners"
            :items="enterpriceOwners"
            @change="$emit('filterTable', searchData)"
            item-text="name"
            item-value="name"
            :hide-no-data="!enterpriceOwners"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_owners">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>

      <div class="col-lg-6 py-0">
        <div class="input_wrapper top_label auto_complete">
          <label class="form-label"> إسم العميل المسئول</label>
          <v-autocomplete
            v-model="searchData.username"
            :search-input.sync="searchOptions.search_users"
            :items="users"
            @change="$emit('filterTable', searchData)"
            item-text="name"
            item-value="name"
            :hide-no-data="!users"
            dense
          ></v-autocomplete>
          <button class="button_style_1 load_inline" v-if="load_users">
            <span class="btn_loader"></span>
          </button>
        </div>
      </div>

      <div class="col-lg-12 text-center py-0">
        <button
          class="button_style_1"
          @click="$emit('filterTable', searchData)"
        >
          بحث
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      load_users: false,
      load_owners: false,

      // search
      searchData: {
        username: null,
        enterpriceOwner: null,
      },
      searchOptions: {
        search_users: "",
        enterpriceOwners: "",
      },
      users: null,
      enterpriceOwners: null,
    };
  },
  watch: {
    [`searchOptions.search_users`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.users = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_users(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_users(newVal);
        } else {
          this.get_filterd_users(newVal);
        }
      }
    },

    [`searchOptions.enterpriceOwners`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.enterpriceOwners = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_enterprice_owners(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_enterprice_owners(newVal);
        } else {
          this.get_enterprice_owners(newVal);
        }
      }
    },
  },
  methods: {
    // get_filterd_users
    get_filterd_users(keyword) {
      this.load_users = true;
      this.$axios({
        method: "GET",
        url: `client/customer/search?keyword=${keyword}`,
      })
        .then((res) => {
          this.users = res.data.data;
          this.load_users = false;
        })
        .catch((err) => {
          this.load_users = false;
        });
    },

    get_enterprice_owners(keyword) {
      this.load_owners = true;
      this.$axios({
        method: "GET",
        url: `help/owners?keyword=${keyword}`,
      })
        .then((res) => {
          this.load_owners = false;
          this.enterpriceOwners = res.data.data;
        })
        .catch((err) => {
          this.load_owners = false;
        });
    },
  },
};
</script>

<style lang="scss">
.search-section .load_inline {
  width: 30px !important;
  height: 25px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0 !important;
  left: 1px;
  position: absolute !important;
  background: transparent !important;
  margin: 0 !important;

  span {
    right: 0 !important;
    left: 0 !important;
    margin: auto !important;
    border-top: 3px solid var(--mainColor-2) !important;
    border-right: 3px solid transparent !important;
  }
}
</style>
